export default __webpack_public_path__ + "static/media/imagecutout_original.7f2dc1f7.jpg";